/**
 * Outbound Partner-API clients ("Outbound API Integration", REV-21638):
 * credentials an ORG_ADMIN hands to third-party tools. Mirrors the
 * partner-clients DTOs of aumico-be.
 */

export type PartnerScope = 'read:organization' | 'read:companies' | 'read:financials' | 'write:mappings';

/** Wire values + their i18n label keys, in display order. */
export const PARTNER_SCOPE_OPTIONS: ReadonlyArray<{ scope: PartnerScope; labelKey: string }> = [
    { scope: 'read:organization', labelKey: 'aumico_outbound_api_scope_read_organization' },
    { scope: 'read:companies', labelKey: 'aumico_outbound_api_scope_read_companies' },
    { scope: 'read:financials', labelKey: 'aumico_outbound_api_scope_read_financials' },
    { scope: 'write:mappings', labelKey: 'aumico_outbound_api_scope_write_mappings' },
];

export interface IPartnerClient {
    id: string;
    clientId: string;
    displayName: string;
    scopes: PartnerScope[];
    status: 'active' | 'revoked';
    createdAt: string | null;
    secretRotatedAt: string | null;
}

/** Returned exactly once per create/rotate; the secret must never enter the store. */
export interface IPartnerClientWithSecret extends IPartnerClient {
    clientSecret: string;
}

export interface ICreatePartnerClientBody {
    displayName: string;
    scopes: PartnerScope[];
}
